import React, { FC, Fragment, InputHTMLAttributes } from "react";
import Check from "../Icons/fill/Check";
import { InputStyled, CheckboxStyled, RadioStyled } from "./InputStyled";
import ErrorMessage from "../ErrorMessage";
import { trackEvent } from "~/helpers/tracking";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  masked?: boolean;
  registerProps?: Record<string, unknown>;
  error?: string;
  isSimplified?: boolean;
}

const Input: FC<Props> = ({ registerProps = {}, error, ...props }) => {
  const { type } = props;
  const handleFieldInputted = (event) => {
    trackEvent({
      action: "fieldInputted",
      event,
    });
  };

  if (type === "checkbox") {
    return (
      <CheckboxStyled isSimplified={props.isSimplified}>
        <input {...props} {...registerProps} />
        <span>
          <Check />
        </span>
      </CheckboxStyled>
    );
  }

  if (type === "radio") {
    return (
      <RadioStyled>
        <input {...props} {...registerProps} />
        <span />
      </RadioStyled>
    );
  }

  return (
    <Fragment>
      <InputStyled
        onBlur={handleFieldInputted}
        {...props}
        {...registerProps}
        error={error}
        data-private="lipsum"
        className="fs-mask"
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Fragment>
  );
};

Input.displayName = "Input";

export default Input;
